import * as yup from "yup";

export type MakeMeasuredFormValues = {
    isPrimary: number;
    justification: string;
};

export const makeMeasuredFormValidationSchema = yup.object({
    justification: yup.string().required("Please enter a justification"),
});

export const defaultMakeMeasuredFormValues: Partial<MakeMeasuredFormValues> = {
    isPrimary: 1,
};
